import { debounce } from 'lodash-es';

export default function (propertyName, debounceAmount = 0, debounceConfig = {}) {
  return {
    data: () => ({
      onWindowResizeDebounced: null,
      [propertyName]: {
        width: 0,
        height: 0,
      },
    }),
    created() {
      if (this.$isServer) return;

      this.onWindowResizeListener = () => {
        // window.pageX/YOffset is equivalent to window.scrollX/Y, but works in IE
        // We round values because high-DPI devices can provide some really nasty subpixel values
        this[propertyName].width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        this[propertyName].height = Math.max(document.documentElement.clientHeight, window.innerWidth || 0);
      };

      // Call listener once to detect initial position
      this.onWindowResizeListener();

      // When scrolling, update the position
      this.onWindowResizeDebounced = debounce(this.onWindowResizeListener, debounceAmount, debounceConfig);

      window.addEventListener('resize', this.onWindowResizeDebounced);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onWindowResizeDebounced);
    },
  };
}
